import { render, staticRenderFns } from "./RoutesTable.vue?vue&type=template&id=288a642b&scoped=true&"
import script from "./RoutesTable.vue?vue&type=script&lang=js&"
export * from "./RoutesTable.vue?vue&type=script&lang=js&"
import style0 from "./RoutesTable.vue?vue&type=style&index=0&id=288a642b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a642b",
  null
  
)

export default component.exports
import {QCard,QTable,QInput,QIcon,QCardSection,QSeparator,QPopupProxy} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QInput,QIcon,QCardSection,QSeparator,QPopupProxy})
